import styled from "styled-components";

import { hideScrollBar } from "../../../../../../../../../commonStyles";

export const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};

  * {
    ${hideScrollBar}
  }
`;
